import { ChannelType, VirtualConversationType } from '../models/reports.internal';

export interface IconAndTextDetails {
  text: string;
  icon: string;
}

export function getVirtualConversationDetails(virtualConversationType: VirtualConversationType): IconAndTextDetails {
  switch (virtualConversationType) {
    case 'Preview':
      return { text: 'Campaign preview', icon: 'ArrowUpRight' };
    case 'Callback':
      return { text: 'Campaign callback', icon: 'Reply' };
    default:
      return { text: '', icon: '' };;
  }
}

export function getChannelTypeDetails(channelType: ChannelType): IconAndTextDetails | null {
  switch (channelType.toLowerCase()) {
    case 'directline':
      return { text: 'Direct line', icon: 'CommentPrevious' };
    case 'email':
      return { text: 'Email', icon: 'Mail' };
    case 'facebook':
      return { text: 'Facebook', icon: 'FacebookLogo' };
    case 'infobip_sms':
      return { text: 'Infobip SMS', icon: 'CellPhone' };
    case 'instagram':
      return { text: 'Instagram', icon: 'InstagramLogo' };
    case 'sms':
      return { text: 'SMS', icon: 'CannedChat' };
    case 'viber':
      return { text: 'Viber', icon: 'ViberLogo' };
    case 'virtual':
      return { text: 'Campaign', icon: 'Flag' };
    case 'voice':
      return { text: 'Voice', icon: 'Phone' };
    case 'webchat':
      return { text: 'Web\u00a0chat', icon: 'OfficeChat' };
    case 'whatsapp':
      return { text: 'WhatsApp', icon: 'WhatsAppLogo' };

    default:
      return null;
  }
}